export default {
	methods: {
		showSubMenu() {
			document.querySelector('.main-menu .sub-menu').classList.toggle('shown');
		}
	}
};


// WEBPACK FOOTER //
// ./src/components/main-menu/main-menu.js